export const alertConstant = {
    SUCCESS: 'ALERT_SUCCESS',
    INFO: 'ALERT_INFO',
    WARNING: 'ALERT_WARNING',
    ERROR: 'ALERT_ERROR',
    CLEAR: 'ALERT_CLEAR'
};
